import { render, staticRenderFns } from "./QuestionSlide.vue?vue&type=template&id=7b4539e4&"
import script from "./QuestionSlide.vue?vue&type=script&lang=js&"
export * from "./QuestionSlide.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSlide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports